export const keys = {
    backspace: 'Backspace',
    tab: 'Tab',
    enter: 'Enter',
    shift: 'Shift',
    esc: 'Escape',
    space: ' ',
    pageUp: 'PageUp',
    pageDown: 'PageDown',
    end: 'End',
    home: 'Home',
    left: 'ArrowLeft',
    up: 'ArrowUp',
    right: 'ArrowRight',
    down: 'ArrowDown',
    delete: 'Delete',
    slash: '/',
};
export var Keys;
(function (Keys) {
    Keys["Backspace"] = "Backspace";
    Keys["Tab"] = "Tab";
    Keys["Enter"] = "Enter";
    Keys["Shift"] = "Shift";
    Keys["Esc"] = "Escape";
    Keys["Space"] = "Space";
    Keys["PageUp"] = "PageUp";
    Keys["PageDown"] = "PageDown";
    Keys["End"] = "End";
    Keys["Home"] = "Home";
    Keys["Left"] = "ArrowLeft";
    Keys["Up"] = "ArrowUp";
    Keys["Right"] = "ArrowRight";
    Keys["Down"] = "ArrowDown";
    Keys["Delete"] = "Delete";
    Keys["Slash"] = "/";
})(Keys || (Keys = {}));
//# sourceMappingURL=keyCodes.js.map